import styled from '@emotion/styled';
import { Button } from '../../../components';

const hoverColor = '#d6d6d6';
const borderColor = '#e5e5e5';

const CompareTable = styled.table`
  line-height: 1.42857143;
  border-spacing: 0;
  border-bottom: 1px solid ${borderColor};
  overflow-x: auto;
`;
export default CompareTable;

// blank cells to fill legend rows
export const BlankTd = styled.td`
  border-top: 1px solid ${borderColor};
  border-right: 1px solid ${borderColor};
  box-shadow: ${props => (props.column === 0 ? 'inset 5px 0 5px -4px #e2e2e2' : 'default')};
`;

// Legend (categories)
export const LegendTh = styled.th`
  position: sticky;
  left: 0;
  background-color: white;
  font-family: ${props => props.theme.fontFamily};
  font-size: ${props => props.theme.fontSize_base};
  font-weight: 700;
  text-align: left;
  padding: 15px;
  border-left: 1px solid ${borderColor};
  border-right: 1px solid ${borderColor};
  border-top: 1px solid ${borderColor};
  min-width:275px;
  max-width:275px;
  &:hover {
    background-color: ${props => (props.editAvailable ? hoverColor : 'inherit')};
  }
`;

// Names of Benefits on the left.
export const CategoryTh = styled.th`
  position: sticky;
  left: 0;
  background-color: inherit;
  font-size: ${props => props.theme.fontSize_base};
  font-family: ${props => props.theme.fontFamily};
  font-weight: 600;
  text-align: left;
  padding: 15px;
  border-left: 1px solid ${borderColor};
  border-right: ${props => (props.colSpan === '2' ? `1px solid ${borderColor}` : 'default')};
  padding-right: ${props => (props.colSpan === '2' ? '20px' : 'default')};
  &:hover {
    background-color: ${props => (props.editAvailable ? hoverColor : 'default')};
  }
  min-width:100px;
  max-width:100px;
`;

// Name of the subcategories
export const SubCategoryTh = styled.th`
position: sticky;
left: 152px;
background-color: inherit;
font-size: ${props => props.theme.fontSize_base};
font-family: ${props => props.theme.fontFamily};
font-weight: 400;
text-align: right;
padding-right: 20px;
word-wrap: break-word;
border-right: 1px solid ${borderColor};
&:hover {
  background-color: ${props => (props.editAvailable ? hoverColor : 'default')};
}
min-width:110px;
max-width:110px;
`;

// Rows of the benefits
export const Row = styled.tr`
  /* Maintain cell widths while dragging */
  display: ${props => (props.isDragging ? 'table' : 'table-row')};
  :nth-of-type(odd) {
    background-color: white;
  }
  :nth-of-type(even) {
    background-color: #fafafa;
  }
`;

// Details
export const BenefitTd = styled.td`
  cursor: text;
  font-family: ${props => props.theme.fontFamily};
  font-size: ${props => props.theme.fontSize_base};
  font-weight: 400;
  color: ${props => props.theme.color};
  padding: 15px;
  word-wrap: break-word;
  border-right: 1px solid ${borderColor};
  box-shadow: ${props => (props.column === 0 ? 'inset 5px 0 5px -4px #e2e2e2' : 'default')};
  &:hover {
    background-color: ${props => (props.editAvailable ? hoverColor : 'default')};
  }
  min-width: 300px;
  max-width:300px;
`;

export const NavButton = styled(Button)`
  position: fixed;
  display: ${props => (props.isInvisible ? 'none' : 'auto')};
  height: 80px;
  top: ${props => props.verticalPlacement};
  right: 0;
`;
